import GreyColumn from '../GreyColumn'

type StatisticsProps = {
  quantity: string | number
  refills: string | number
  daysSupply?: number
}

const Statistics = ({ quantity, refills, daysSupply }: StatisticsProps) => {
  const rows = [
    { label: 'Quantity', value: quantity },
    { label: 'Refills', value: refills },
    { label: 'Days supply', value: daysSupply },
  ]

  return (
    <div className="flex mt-2 gap-5 flex-wrap">
      {rows.map(({ label, value }) => (
        <GreyColumn label={label} value={value} key={label} />
      ))}
    </div>
  )
}

export default Statistics
